import * as React from 'react';
import { IRegisterModal } from './interfaces';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

export const RegisterModal: React.FC<IRegisterModal> = ({
  show,
  title,
  description,
  isPending = false,
  onClose,
  onRegister,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={show} onClose={onClose}>
      <DialogTitle
        sx={{
          position: 'relative',
        }}
      >
        <Typography variant="h2" fontSize="1.2rem" fontWeight="bold">
          {t('competitions:portal.dialogs.register.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('competitions:portal.dialogs.register.subTitle')}
        </Typography>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6" fontSize="1rem" fontWeight="bold">
          {title}
        </Typography>
        {description && (
          <Typography
            variant="body2"
            sx={{ mt: 1, whiteSpace: 'pre-line' }}
          >
            {description}
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          autoFocus
          onClick={onRegister}
          variant="contained"
          disabled={isPending}
        >
          Aanmelden
        </Button>
      </DialogActions>
    </Dialog>
  );
};
